import { Container } from './styles';
import { ProjectCard } from './ProjectCard';
import { projects, ProjectCategory } from './projectsData';

const categoryOrder: { id: ProjectCategory; title: string; subtitle: string }[] = [
  {
    id: 'production',
    title: 'Production Systems',
    subtitle: 'Deployed AI serving real users',
  },
  {
    id: 'research',
    title: 'Research & Publications',
    subtitle: 'Peer-reviewed work and applied research',
  },
  {
    id: 'open-source',
    title: 'Open Source & Prototypes',
    subtitle: 'Public repositories and rapid experiments',
  },
];

export function Project() {
  return (
    <Container id="project">
      <h2>Projects</h2>
      {categoryOrder.map(({ id, title, subtitle }) => {
        const items = projects.filter((p) => p.category === id);
        if (items.length === 0) return null;
        return (
          <div key={id} className="category-group">
            <header className="category-heading">
              <h3>{title}</h3>
              <span>
                {subtitle} · {items.length}
              </span>
            </header>
            <div className="projects">
              {items.map((project) => (
                <ProjectCard key={project.title} project={project} />
              ))}
            </div>
          </div>
        );
      })}
    </Container>
  );
}
